import Link from "../../Link";

const Laravel = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/56" title={"OpenBootcamp Laravel(PHP)"} />
        </div>
    );
}

export default Laravel;